import {
  Box,
  Button,
  Flex,
  Modal,
  ModalContent,
  ModalOverlay
} from '@chakra-ui/react'
import {
  GreyGrey0,
  GreyGrey100,
  GreyGrey80,
  Lato13Bold,
  Lato13Regular,
  Lato14Bold
} from '@sequencehq/design-tokens'
import { FC } from 'react'

type ConfirmDeleteLatestQuoteDraftModalProps = {
  onClose: () => void
  onConfirm: () => void
  submitting: boolean
}

export const ConfirmDeleteLatestQuoteDraftModal: FC<
  ConfirmDeleteLatestQuoteDraftModalProps
> = props => {
  return (
    <Modal isOpen onClose={props.onClose}>
      <ModalOverlay>
        <ModalContent
          backgroundColor={GreyGrey0}
          padding="16px"
          borderRadius="8px"
          top="118px"
          width="414px"
          maxWidth="414px"
        >
          <Box color={GreyGrey100} {...Lato14Bold} marginBottom="4px">
            Delete draft changes
          </Box>
          <Box {...Lato13Regular} color={GreyGrey80} marginBottom="16px">
            You’re about to delete your draft changes. The quote will revert to
            the latest published variant.
          </Box>
          <Flex gap="8px" justifyContent="flex-end">
            <Button
              variant="secondary2"
              onClick={props.onClose}
              height="32px"
              width="100%"
              {...Lato13Bold}
            >
              Cancel
            </Button>
            <Button
              variant="warning2"
              isLoading={props.submitting}
              onClick={props.onConfirm}
              height="32px"
              width="100%"
              {...Lato13Bold}
            >
              Delete
            </Button>
          </Flex>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  )
}
